module.exports = __webpack_public_path__ + "static/media/icon-more.b2e62000.svg";